// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconCheck[data-v-0b5d6bbe]{stroke:#413dff}.iconCheck.novikov[data-v-0b5d6bbe]{stroke:#ee1623}.privacyPolicy__checkbox .iconCheck.novikov[data-v-0b5d6bbe],.serviceFee__checkbox .iconCheck.novikov[data-v-0b5d6bbe]{stroke:#0a0a0a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
